<template>
  <div>
    <!-- 创建活动 -->
    <el-drawer :visible.sync="dvisible" :with-header="false" size="60%" :before-close="handleAddClose">
        <el-card shadow="never" class="drawer_body_100">
          <div slot="header" class="clearfix">
            <span>活动内容</span>
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto" size="mini">
            <el-form-item label="活动名称" prop="activityName">
              <el-input v-model="ruleForm.activityName"></el-input>
            </el-form-item>
            <el-form-item label="活动时间" prop="startDate">
              <el-date-picker
                v-model="activityDate"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                @change="handleActivityTime">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="活动备注" prop="bz">
              <el-input type="textarea" v-model="ruleForm.bz"></el-input>
            </el-form-item>
            <el-form-item label="代金券礼包设置" prop="activityRule">
              <el-button type="info" @click="handleCouponRuleOpenOrClosed">添加代金券规则</el-button>
              <el-table :data="ruleForm.activityRule" style="width: 100%" size="mini">
                <el-table-column prop="denomin" label="面额"></el-table-column>
                <el-table-column prop="second" label="消费次数"></el-table-column>
                <el-table-column prop="quota" label="消费金额门槛"></el-table-column>
                <el-table-column prop="range" label="消费应用范围"></el-table-column>
                <el-table-column label="操作" width="100">
                  <template slot-scope="scope">
                    <el-button @click="delRule(scope.$index, scope.row)" type="text" size="small">移除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" @click="submitForm">确认保存</el-button>
            </el-form-item>
          </el-form>

        </el-card>
    </el-drawer>


    <!-- 代金券消费规则设置 -->
    <el-dialog title="代金券消费规则设置" :visible.sync="couponRuleVisible" :before-close="handleCouponRuleOpenOrClosed" width="50%">
      <el-form :model="couponForm" :rules="couponFormRules" ref="couponForm" label-width="auto" size="mini">
        <el-form-item label="发放券数量" prop="couponCount">
          <el-input v-model="couponForm.couponCount" type="number"></el-input>
        </el-form-item>
        <el-form-item label="代金券面额" prop="denomin">
          <el-input v-model="couponForm.denomin">
            <template slot="append">元</template>
          </el-input>
        </el-form-item>
        <el-form-item label="消费次数设置" prop="secondState">
          <el-radio-group v-model="couponForm.secondState" @change="onSecondRange">
            <el-radio label="0">消费<el-input-number type="number" v-model="couponForm.second" :controls="false" style="width:50px"></el-input-number>次</el-radio>
            <el-radio label="-1">不限次数</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="消费金额门槛" prop="quota">
          <el-input v-model="couponForm.quota"></el-input>
        </el-form-item>
        <el-form-item label="有效时间设置" prop="startDate">
          <el-date-picker
            v-model="ruleCouponTime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd HH:mm:ss"
            @change="handleRuleCouponTime">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="消费应用范围" prop="range">
          <el-radio-group v-model="couponForm.range" @change="onRange">
            <el-radio label="全平台应用"></el-radio>
            <el-radio label="指定应用"></el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="导入应用" v-show="couponForm.flag">
          <el-upload
            :action="`${this.$store.state.upBaseUrl}coupon-market/activity/fileUpload`"
            :headers="myHeaders"
            :limit="1"
            ref="upload"
            accept=".txt"
            :on-success="handleAvatarSuccess"
            :auto-upload="true">
            <el-button slot="trigger" size="mini" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">只能上传txt文件，每次只能上传一个文件</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="指定机型">
          <sam-phone-model @setPhoneModel="setPhoneModel" ref="childModel"></sam-phone-model>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCouponRuleOpenOrClosed">取 消</el-button>
        <el-button type="primary" @click="handleAddRule">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PhoneModel from '../phoneModel'
import moment from 'moment'
export default {
  components:{
      'sam-phone-model':PhoneModel
  },
  props: {
    dvisible: Boolean
  },
  data () {
    return {
      myHeaders: {},
      activityDate:[],
      ruleCouponTime:[],
      couponRuleVisible:false,
      ruleForm: {
        activityName: '',
        bz: '',
        startDate: '',
        endDate: '',
        activityRule:[],//代金券礼包设置
      },
      rules: {
        activityName: [
          { required: true, message: '请输入名称', trigger: 'blur' }
        ],
        activityRule: [
          { required: true, message: '请设置代金券规则', trigger: 'change' }
        ],
        startDate: [
          { required: true, message: '请选择活动时间', trigger: 'blur' }
        ]
      },
      couponForm: {
        flag: false,
        startDenomin:'',
        endDenomin:'',
        denomin: '',
        second: '',
        secondState: '',
        quota:'',
        range:'',
        applyList:[],//指定应用时 上传的应用列表
        modelData:[],//已选机型列表
        startDate:'',
        endDate:''
      },
      couponFormRules: {
        startDenomin: [
          { required: true, message: '请输入代金券起止金额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        endDenomin: [
          { required: true, message: '请输入代金券截止金额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        denomin: [
          { required: true, message: '请输入代金券面额', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        secondState: [
          { required: true, message: '请选择消费次数', trigger: 'change' }
        ],
        quota: [
          { required: true, message: '请输入消费金额门槛', trigger: 'blur' },
          { required: true, message: '请填写正确的金额,保留两位小数',pattern: /(^[\d]|^[1-9][\d]*)($|[\.][\d]{0,2}$)/}
        ],
        startDate: [
          { required: true, message: '请选择有效时间', trigger: 'blur' }
        ],
        range: [
          { required: true, message: '请选择应用范围', trigger: 'change' }
        ]
      }
    }
  },
  created(){
    var token =  window.sessionStorage.getItem('token');
    this.myHeaders = {'oa-token':token}
  },
  methods: {
    //提交 添加活动
    submitForm(){
      let _this = this;
      _this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$ajax({
            url:"coupon-market/activity_active/add",
            async:false,
            methods:'POST',
            data:_this.ruleForm,
            token:window.sessionStorage.getItem('token'),
            success:function(response){
              if (response.code==0) {
                _this.resetForm("ruleForm");
                _this.$parent.query();
                _this.$message.success('添加成功');
              }else{
                _this.$message.error(response.message);
              }
            },
            error:function(){
              _this.$message.error("请求失败");
            }
          })
        } else {
          _this.$message.error('请输入必填项!!');
          return false;
        }
      });
    },
    //上传应用文件处理
    handleAvatarSuccess(res, file) {
      if (res.code == 0) {
        this.couponForm.applyList=res.data
        this.$alert('上传成功!', '提示', {
          confirmButtonText: '确定',
        });
      }
    },
    //抽屉关闭方法
    handleAddClose() {
      this.$parent.handleOpenOrClosed();
    },
    //代金券规则显示或关闭
    handleCouponRuleOpenOrClosed(){
      this.couponRuleVisible = !this.couponRuleVisible;
    },
    //重置代金券规则表单
    resetFormCoupon(formName) {
      this.ruleCouponTime = [];
      this.couponForm.secondState = '';
      this.couponForm.second = '';
      this.couponForm.modelData = [];
      this.couponForm.applyList = [];
      this.$refs.upload.clearFiles();
      this.$refs.childModel.handleClear();
      this.$refs[formName].resetFields();
    },
    //设置选择机型
    setPhoneModel(models){
      this.couponForm.modelData = models;
    },
    //应用范围选择
    onRange(value){
      if (value === "指定应用") {
        this.couponForm.flag = true;
      }else {
        this.couponForm.flag = false;
      }
    },
    //消费次数设置
    onSecondRange(val){
      if (val === "-1") {
        this.couponForm.second = "-1";
      }
    },
    //添加规则 页面
    handleAddRule(){
      let _this = this;
      this.$refs.couponForm.validate((valid) => {
        if (valid) {
          let row = Object.assign({},_this.couponForm);//Object.create(_this.couponForm);
          _this.ruleForm.activityRule.push(row);
          _this.resetFormCoupon("couponForm");
          _this.couponRuleVisible = false;
        } else {
          _this.$message.error('请输入必填项!!');
          return false;
        }
      });
    },
    //删除规则 页面
    delRule(index,row){
      this.ruleForm.activityRule.splice(index,1);
    },
    //重置活动表单
    resetForm(formName) {
      this.activityDate = [];
      this.$refs[formName].resetFields();
    },
    //获取活动时间
    handleActivityTime(){
      if (this.activityDate != null) {
				this.ruleForm.startDate = this.activityDate[0];
				this.ruleForm.endDate = this.activityDate[1];
			}else{
        this.ruleForm.startDate = '';
				this.ruleForm.endDate = '';
      }
    },
    //优惠券规则有效期处理
    handleRuleCouponTime(){
      if (this.ruleCouponTime != null) {
        this.couponForm.startDate = this.ruleCouponTime[0];
        this.couponForm.endDate = this.ruleCouponTime[1];
      }else{
        this.couponForm.startDate = '';
				this.couponForm.endDate = '';
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/custom/activityAdd.vue